<template>
  <!-- Informational, not an action: consumption moved, the portfolios catch up on the weekly run. -->
  <div
    class="cg-rebalance d-flex align-items-center gap-2 small text-body-secondary"
    title="Confirmed readings changed the consumption these portfolios were sized on. Soldera re-allocates on the weekly run; nothing moves before then."
  >
    <font-awesome-icon icon="clock" class="cg-rebalance__icon" />
    <span>
      Portfolio rebalancing scheduled ·
      <span class="cg-tabular fw-medium text-body">{{ note.date }}</span>
    </span>
  </div>
</template>

<script setup lang="ts">
import type { RebalanceNote } from "@/compliance_groups/fixture/derive";

defineProps<{ note: RebalanceNote }>();
</script>

<style scoped lang="scss">
.cg-rebalance {
  padding: 0.25rem 0.625rem;
  border: 1px solid var(--phoenix-card-border-color);
  border-radius: 999px;
  background: var(--phoenix-emphasis-bg);
  white-space: nowrap;
}
.cg-rebalance__icon {
  color: var(--phoenix-primary);
}
</style>
